import { DiscountComponent } from './discounts'
import { ORDER_TYPE } from './order-type'
import { TaxComponent } from './tax'

export type ItemDefaultsInfo = {
  defaultPrice: number
  defaultQuantityType: string
  defaultQuantityTypeShort: string
}

export interface DiscountInfo {
  // Give 1.Cash Discounts 2.lowest discount % to highest
  discountSno: number
  discountComponent: DiscountComponent
  amountBeforeDiscount: number
  discountAmount: number
  amountAfterDiscount: number //amountBeforeTax
}

interface TaxInfo {
  taxComponent: TaxComponent
  taxableAmount: number
  taxAmount: number
}

export interface ItemBillingDiscountInfo {
  isDiscountApplied: boolean
  discountsInfo: DiscountInfo[]
  amountBeforeDiscount: number
  discountAmount: number
  amountAfterDiscount: number //amountBeforeTax
}

export interface ItemBillingTaxInfo {
  isTaxApplied: boolean
  taxInfo: TaxInfo[]
  amountBeforeTax: number
  taxAmount: number
  amountAfterTax: number
}

export interface ItemBillingInfo {
  discounts: ItemBillingDiscountInfo
  tax: ItemBillingTaxInfo
  rawAmount: number
  totalDiscountGiven: number
  totalTaxCharged: number
  finalAmount: number
}

export enum KITCHEN_ITEM_STATUS {
  All = 'ALL',
  ALL = 'ALL',
  IN_CART = 'IN_CART',
  IN_KITCHEN = 'IN_KITCHEN',
  COOKING = 'COOKING',
  READY = 'READY',
  SERVED = 'SERVED',
  CANCELLED = 'CANCELLED',
}

export interface ItemKitchInfo {
  status: KITCHEN_ITEM_STATUS
  kitchenId: string
  kitchenInstrcutions: string
  itemReceviedTime: string
  itemReadyTime: string
  itemServedTime: string
  updatedAt?: string
}

export interface BillItem {
  productId: string
  sno: number
  yearSno: string
  itemName: string
  itemImage: string
  itemPrice: number //new
  totalExtrasPrice: number //new
  finalPrice: number //new
  extras: { [extraName: string]: number } //new
  amount: number
  mrp: number
  noOfItems: number
  quantity: number
  quantityType: string
  quantityTypeShort: string
  rateCardName: string
  default: ItemDefaultsInfo
  billingInfo: ItemBillingInfo
  kitchInfo: ItemKitchInfo
  createdAt?: string
}

export interface FullBillingInfo {
  totalItemsCostRaw: number
  totalDiscountIssued: number
  totalTaxCharged: number
  TaxChargeSheetView: { [key: string]: number }
  finalBillAmount: number,
  extraInfo?: {[key: string]: string}
}

export interface FullTimeInfo {
  billDate: string // 27-06-2024
  billTime: string // 9:30 AM
  timestamp: string // 17875348733
  timezone: string // "CST" ...
  year: number // 2024
}

export interface BillTypeInfo {
  createdBy: string
  sessionId: string
  tableId: string
  tableName: string
  tableNo: string
}

export enum TAKEAWAY_STATUS {
  PENDING = 'PENDING',
  READY = 'READY',
  DONE = 'DONE',
}

export interface BillType {
  _id?: string
  billNo: string
  sNo: number
  clientId: string
  orderType: ORDER_TYPE
  takeAwayType: string
  takeAwayStatus: TAKEAWAY_STATUS
  items: Array<BillItem>
  info: BillTypeInfo
  billingInfo: FullBillingInfo
  timeInfo: FullTimeInfo
  modeOfPayment: string
  createdAt?: string
}
